import { render, staticRenderFns } from "./mdlDisplayfield.vue?vue&type=template&id=454cacf7&scoped=true"
import script from "./mdlDisplayfield.vue?vue&type=script&lang=js"
export * from "./mdlDisplayfield.vue?vue&type=script&lang=js"
import style0 from "./mdlDisplayfield.vue?vue&type=style&index=0&id=454cacf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454cacf7",
  null
  
)

export default component.exports